import React, { useState } from 'react';
import { AppBar, Toolbar, Box, IconButton, Drawer, List, ListItemButton, ListItemText, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link, useLocation } from 'react-router-dom';
import NavBarItems from './NavBarItems';
import LanguageSwitch from './LanguageSwitch';
import MALogo from '../../assets/images/MALogo4.png';
import menuConfig from '../../assets/configs/menuConfig';
import { useLang } from '../../utils/i18n';

const NavBar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const [lang] = useLang();

  return (
    <>
      <AppBar
        position="sticky"
        color="default"
        elevation={0}
        sx={{ bgcolor: 'background.paper', zIndex: 1400, backdropFilter: 'blur(6px)' }}
      >
        <Toolbar sx={{ justifyContent: 'start', gap: 2, width: '100%' }}>
          <Box
            component="img"
            src={MALogo}
            alt="MA Logo"
            sx={{ height: { xs: 32, md: 38 }, width: 'auto', objectFit: 'contain' }}
          />
          <NavBarItems />
          <Box sx={{ flexGrow: 1 }} />
          <LanguageSwitch size="small" />
          <IconButton
            edge="end"
            aria-label="menu"
            onClick={() => setDrawerOpen(true)}
            sx={{ display: { xs: 'flex', md: 'none' }, color: 'text.primary' }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 220, bgcolor: 'background.paper', pt: 1 } }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1 }}>
          <IconButton onClick={() => setDrawerOpen(false)} aria-label="close menu">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List>
          {menuConfig.sidebarData.map((item) => {
            const active = location.pathname === item.path;
            return (
              <ListItemButton
                key={item.id}
                component={Link}
                to={item.path}
                onClick={() => setDrawerOpen(false)}
                sx={{
                  borderLeft: active ? '3px solid' : '3px solid transparent',
                  borderLeftColor: active ? 'primary.main' : 'transparent',
                  pl: 2.5,
                }}
              >
                <ListItemText
                  primary={item.title_i18n?.[lang] || item.title}
                  primaryTypographyProps={{ fontWeight: active ? 700 : 500 }}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Drawer>

      {/* AppBar is position="sticky", not "fixed", so this spacer isn't needed —
          commented out (not deleted) in case we go back to a fixed AppBar. */}
      {/* <Box sx={(theme) => ({ ...theme.mixins.toolbar })} /> */}
    </>
  );
};

export default NavBar;
